<template>
  <v-row>
    <v-col cols="12" class="mt-10">
      <v-col cols="12" md="6" class="py-0 ml-auto">
        <v-text-field
          dark
          single-line
          hide-details
          color="yellow"
          label="Pesquisar"
          append-icon="mdi-magnify"
          v-model="search"></v-text-field>
      </v-col>
      <v-data-table
        dark
        class="elevation-2 mt-4"
        :search="search"
        :items="profiles"
        :headers="headers"
        :items-per-page="10">
        <template v-slot:body="{ items }">
          <tbody>
            <tr v-if="loadingTable" class="no-hover" style="text-align: center">
              <td :colspan="headers.length">
                <v-progress-circular
                  :size="50"
                  color="yellow"
                  class="ma-5"
                  indeterminate></v-progress-circular>
              </td>
            </tr>
            <tr class="tr-click" v-for="profile in items" :key="profile.id">
              <td class="pr-0" @click="setProfileDataOnForm(profile)">
                <div
                  :style="
                    (profile.active ? 'background: #4CAF50; ' : 'background: #FF5722; ') +
                    'height: 10px; width: 10px; border-radius: 50%;margin: auto;'
                  "></div>
              </td>
              <td @click="setProfileDataOnForm(profile)">
                {{ profile.name }}
              </td>
              <td style="text-align: center" @click="setProfileDataOnForm(profile)">
                <v-chip>{{ profile.roles.length }}</v-chip>
              </td>
              <td style="text-align: center" @click="setProfileDataOnForm(profile, true)">
                <v-chip>{{ profile.users.length }}</v-chip>
              </td>
            </tr>
            <tr class="no-hover" v-if="!loadingTable && !items.length" style="text-align: center">
              <td :colspan="headers.length">
                <p class="mt-4">Nenhum perfil encontrado</p>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-col>
    <v-btn fab right bottom absolute color="yellow" @click="openCreateModal()">
      <v-icon> mdi-plus </v-icon>
    </v-btn>

    <v-dialog persistent v-model="dialog" max-width="700px" transition="dialog-bottom-transition">
      <v-card dark style="border: 1px solid #000">
        <v-card-text class="pb-4">
          <v-form ref="form" lazy-validation>
            <v-row class="mt-1">
              <v-col cols="12" class="pb-0">
                <v-text-field
                  label="Nome"
                  color="yellow"
                  class="name-input-field"
                  :disabled="!active"
                  :rules="nameRules"
                  v-model="name"></v-text-field>
              </v-col>
              <v-col cols="12" class="pb-0 pt-0">
                <role-tree
                  v-if="roles"
                  v-model="roles"
                  :all-roles="allRoles"
                  :disabled="!active" />
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-switch
            label="Ativo"
            v-show="!createForm"
            inset
            hide-details
            class="ml-3"
            style="margin: auto"
            color="yellow"
            v-model="active"></v-switch>
          <v-spacer></v-spacer>
          <v-btn text @click="closeModal()"> Fechar </v-btn>
          <v-btn color="yellow" text @click="update()"> Salvar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Usuários -->
    <v-dialog
      scrollable
      persistent
      max-width="600"
      transition="dialog-bottom-transition"
      v-model="dialogUsers">
      <v-card dark style="border: 1px solid #000" height="90vh">
        <v-card-title>Usuários ({{ usersSelected.length }})</v-card-title>
        <v-card-text style="height: 300px" class="pa-0">
          <v-text-field
            dense
            hide-details
            solo-inverted
            color="yellow"
            placeholder="Pesquisar"
            class="mt-0 pt-0 rounded-0"
            prepend-inner-icon="mdi-magnify"
            v-model="searchUser"></v-text-field>
          <v-divider></v-divider>
          <v-list class="pa-0" two-line>
            <v-list-item-group v-model="users" multiple>
              <v-list-item
                v-for="user in usersFiltered"
                :key="user.id"
                :value="user.id"
                @click="changeUser(user.id)">
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>

                  <v-list-item-avatar class="mr-4">
                    <v-img
                      v-if="user.profile_photo"
                      :src="user.profile_photo.url"
                      title="Foto"></v-img>
                    <v-img v-else src="@/assets/images/no-photo.jpg" title="Foto"></v-img>
                  </v-list-item-avatar>

                  <v-list-item-content>
                    <v-list-item-title>{{ user.name }}</v-list-item-title>
                    <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="closeModal(true)" :disabled="loading"> Fechar </v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="yellow" :loading="loading" :disabled="loading" @click="update(true)">
            Salvar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script lang="ts">
import { getUsers } from "@/services/user";
import { getRoles } from "@/services/roles";
import { Vue, Component } from "vue-property-decorator";
import RoleTree from "@/components/RoleTree.vue";
import { createProfile, getProfiles, updateProfile } from "@/services/profiles";
import { orderByName } from "@/utils/sort";

@Component({
  components: { RoleTree },
})
export default class Profile extends Vue {
  $refs!: any;
  active = true;
  nameRules: Array<(v: any) => boolean | string> = [(v: any) => !!v || "O nome é obrigatório"];
  rolesRules: Array<(v: any) => boolean | string> = [
    (v: any) => (!!v && (!!v.length || typeof v === "number")) || "O aplicativos é obrigatório",
  ];
  dialog = false;
  dialogUsers = false;
  loading = false;
  loadingTable = true;
  apps: any = [];
  allRoles: any = [];
  allUsers: any = [];
  search: any = "";

  profiles: any = [];

  currentId = "";
  name = "";
  searchUser: any = "";
  roles: any = [];
  users: any = [];
  usersSelected: any = [];
  backupUsers: any = [];

  createForm = false;

  headers = [
    {
      text: "",
      align: "center",
      sortable: false,
      value: "active",
      width: "1%",
    },
    {
      text: "Nome",
      align: "start",
      sortable: false,
      value: "name",
    },
    {
      text: "Permissões",
      align: "center",
      sortable: false,
      value: "apps",
      width: "20%",
    },
    {
      text: "Usuários",
      align: "center",
      sortable: false,
      value: "users",
      width: "20%",
    },
  ];

  get usersFiltered() {
    this.users = this.usersSelected;
    let users = this.allUsers.filter((item: any) => {
      return item.name.toLowerCase().indexOf(this.searchUser.toLowerCase()) > -1;
    });
    return users;
  }

  async mounted(): Promise<void> {
    await getUsers()
      .then((res: any) => {
        this.allUsers = res.data;
        this.allUsers = orderByName(this.allUsers);
      })
      .catch((error: any) => {
        console.error(error);
        this.$emit("snackbar", {
          message: "Erro ao carregar os usuários!",
        });
      });

    await getRoles(["id", "name", "app"])
      .then((res: any) => {
        this.allRoles = res.data;
        this.allRoles.map((item: any) => {
          item.name = item.app === null ? "Auth - " + item.name : item.app.name + " - " + item.name;
        });
        this.allRoles = orderByName(this.allRoles);
      })
      .catch((error: any) => {
        console.error(error);
        this.$emit("snackbar", {
          message: "Erro ao carregar as permissões!",
        });
      });

    await getProfiles()
      .then((res: any) => {
        this.profiles = res.data;
      })
      .catch((error: any) => {
        console.error(error);
        this.$emit("snackbar", {
          message: "Erro ao carregar os perfis!",
        });
      });
    this.loadingTable = false;

    if (Object.keys(this.$route.query).length !== 0) {
      let id: any = atob(this.$route.query.id + "");
      this.setProfileDataOnForm(
        this.profiles.find((p: any) => p.id == id),
        this.$route.query.isUsers
      );
    }
  }

  setProfileDataOnForm(profile: any, isUsers: any = false): void {
    this.addfilters(profile.id, isUsers);

    this.createForm = false;
    this.name = profile.name;
    this.currentId = profile.id;
    this.active = profile.active;

    this.roles = [];
    profile.roles.forEach((r: any) => this.roles.push(r.id ? r.id : r));
    profile.users.forEach((u: any) => this.users.push(u.id + ""));

    if (isUsers) {
      this.usersSelected = [...this.users];

      this.allUsers.sort((a: any, b: any) => {
        const indexA = this.usersSelected.indexOf(a.id);
        const indexB = this.usersSelected.indexOf(b.id);

        // Se um dos usuários está em selectedUsers, coloca ele primeiro
        if ((indexA === -1 && indexB === -1) || (indexA > -1 && indexB > -1)) {
          const first = a.name.toLowerCase();
          const second = b.name.toLowerCase();
          if (first < second) return -1;
          if (first > second) return 1;
          return 0;
        }
        if (indexA === -1) return 1; // Se 'a' não está em selectedUsers, 'b' vem antes
        if (indexB === -1) return -1; // Se 'b' não está em selectedUsers, 'a' vem antes
      });
    }

    isUsers ? (this.dialogUsers = true) : (this.dialog = true);
  }

  roleIsInProfile(role_id: string | number): boolean {
    for (let role of this.roles) {
      if (typeof role === "object") {
        if (role.id == role_id) return true;
      } else {
        if (role == role_id) return true;
      }
    }
    return false;
  }

  userIsInProfile(user_id: string | number): boolean {
    for (let user of this.users) {
      if (user.id == user_id) return true;
    }
    return false;
  }

  openCreateModal(): void {
    this.dialog = true;
    this.createForm = true;
  }

  closeModal(isUsers = false): void {
    if (this.$route.fullPath != this.$route.path) this.setQuery();
    setTimeout(() => {
      this.name = "";
      this.searchUser = "";
      this.roles = [];
      this.users = [];
      this.usersSelected = [];
      this.active = true;
      if (!isUsers) this.$refs.form.reset();
    }, 290);
    isUsers ? (this.dialogUsers = false) : (this.dialog = false);
  }

  /*
   * Atualiza perfil e cria o que defino o tipo do metodo é
   * o atributo createForm (se for true é para criar um novo perfil)
   */
  update(isUsers = false): void {
    if (!isUsers && !this.$refs.form.validate()) return;
    this.loading = true;

    const id = this.currentId;
    const payload = {
      active: this.active,
      name: this.name,
      roles: this.roles.map((role: any) => (role.id ? role.id : role)),
      users: this.users,
    };

    this.createForm
      ? createProfile(payload)
          .then((res: any) => {
            if (res.status == 201) this.closeModal();
            const updatedData = {
              id: res.data.id,
              name: res.data.name,
              active: res.data.active,
              roles: res.data.roles.map((role: any) => {
                return { id: role };
              }),
              users: res.data.users.map((user: any) => {
                return { id: user };
              }),
            };
            this.profiles.push(updatedData);
            this.$emit("snackbar", {
              message: "Criada com sucesso!",
            });
            this.closeModal();
          })
          .catch((error: any) => {
            console.info(error);
            this.$emit("snackbar", {
              message: "Erro ao criar!",
            });
          })
          .finally(() => (this.loading = false))
      : updateProfile(id, payload)
          .then((res: any) => {
            this.profiles.map((profile: any) => {
              if (profile.id == id) {
                profile.name = res.data.name;
                profile.roles = res.data.roles;
                profile.users = res.data.users;
                profile.active = res.data.active;
              }
            });

            this.$emit("snackbar", {
              message: "Editada com sucesso!",
            });
            this.closeModal(isUsers);
          })
          .catch((error: any) => {
            console.info(error);
            this.$emit("snackbar", {
              message: "Erro ao editar!",
            });
          })
          .finally(() => (this.loading = false));
  }

  addfilters(id: any, isUsers: boolean): void {
    if (this.$route.fullPath == this.$route.path) {
      let query: any = {
        id: btoa(id),
        isUsers: isUsers,
      };
      this.setQuery(query);
    }
  }

  setQuery(query: any = {}): void {
    let name: any = this.$route.name;
    this.$router.replace({
      name: name,
      query: query,
    });
  }

  remove(id: any): void {
    const index = this.roles.findIndex((r: any) => (r && r.id ? r.id : r) == id);
    if (index !== -1) {
      this.roles.splice(index, 1);
    }
  }

  changeUser(id: any): void {
    if (this.usersSelected.indexOf(id) > -1) {
      this.usersSelected.splice(this.usersSelected.indexOf(id), 1);
    } else {
      this.usersSelected.push(id);
    }
  }
}
</script>

<style lang="scss" scoped>
.v-list {
  background: #1e1e1e !important;
}
</style>
